import React, { useState } from 'react'
import Sidebar from '../components/Sidebar'
import { Outlet } from 'react-router-dom'
import Header from '../../components/Header/Header'
import img from "../../recruiter/assets/SVG___twist_line_spiral_artistic_-_Free_SVG_Image___Icon____SVG_Silh-removebg-preview.png"

const Layout = () => {
    const [showScroll, setshowScroll] = useState(true)

    return (
        <>
            <Header />
            <div className='flex mt-14 w-full overflow-x-hidden'>
            <div className="fixed -bottom-40 -left-80 z-20 opacity-10 xl:block hidden">
                    <img src={img}/>
                </div>
                <Sidebar/>
                    <Outlet context={{showScroll, setshowScroll}}/>
            </div>
                            
        </>
      )
}

export default Layout